'use client';

import type { Blog } from '@eliadmin/core/src/api/blogs/blogs-types';

import { Button } from '../ui/button';
import { FaFacebook } from 'react-icons/fa';

import { RiLinksFill } from 'react-icons/ri';
import { toast } from '@eliadmin/core/src/components/ui/use-toast';
import { useTranslations } from '@eliadmin/core/src/hooks/use-translations';
import { ROUTES } from '@eliadmin/core/src/constants/routes';
import { Heading } from '../ui/heading';

export function BlogShare({ blog }: { blog: Blog }) {
  const { t } = useTranslations();

  // Blog posts live at the root slug (ROUTES.BLOG_DETAIL); the old `/blog/<slug>` link was a 404.
  const getArticleUrl = () =>
    (blog as any)?.canonical_url ||
    new URL(ROUTES.BLOG_DETAIL({ slug: blog.slug }), window.location.origin).toString();

  const handleCopyLink = async () => {
    if (typeof window === 'undefined') return;

    try {
      // writeText returns a promise; without await a rejected copy still showed the success toast.
      await navigator.clipboard.writeText(getArticleUrl());
      toast({
        title: t('text3835'),
        variant: 'success',
      });
    } catch {
      toast({
        title: t('text4070'),
        variant: 'destructive',
      });
    }
  };

  const handleShare = () => {
    if (typeof window === 'undefined') return;

    const shareUrl = `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(getArticleUrl())}`;

    window.open(shareUrl, '_blank', 'noopener,noreferrer,width=600,height=600');
  };

  return (
    <div className="flex w-full max-w-[926px] flex-col items-start justify-start gap-3">
      <Heading title={t('text1155')} tag="h6" className={{ title: 'text-muted-foreground' }} />
      <div className="flex w-full items-center justify-start gap-2">
        <Button
          variant={'none'}
          onClick={handleCopyLink}
          aria-label={t('text727')}
          className="max-h-[52px] min-h-[52px] min-w-[52px] max-w-[52px] rounded-[16px] bg-[#F9FAFB] !p-0 hover:bg-[#F9FAFB]/90"
        >
          <RiLinksFill size={20} aria-hidden />
        </Button>
        <Button
          variant={'none'}
          onClick={handleShare}
          aria-label={t('text1047')}
          className="max-h-[52px] min-h-[52px] min-w-[52px] max-w-[52px] rounded-[16px] bg-[#F9FAFB] !p-0 hover:bg-[#F9FAFB]/90"
        >
          <FaFacebook size={20} aria-hidden />
        </Button>
      </div>
    </div>
  );
}
